<template lang="pug">
  .syncUseCaseSlim().mt-1
    .content.d-flex.justify-content-center
        .row.d-flex.align-items-strech
            .fieldContent.px-3  
                img(:src="syncType.source.icon" width="40px").px-1
                span {{syncType.source.name}}
            .fieldContent 
                img(src="@/assets/imgs/arrow.svg")
            .fieldContent.px-3
                img(:src="syncType.destination.icon" width="40px").px-1
                span {{syncType.destination.name}}
</template>

<script>
export default {
  name: 'SyncUseCaseSlim',
  props:{
      syncType: Object
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less');
    .syncUseCaseSlim .row {
        background: rgba(50, 204, 183, 0.05);
        border: 1px solid #32CCB7;
        padding: 5px;
        border-radius: 50px;
    }
</style>
